function MyvercoContactController(){
	this.className			= "MyvercoContactController";
	this.view				= false;
	this.glob				= ["/*/myverco/contact**", "/*/myverco/contact?**"];
	// this.glob			= ["/", "/?**"];
	this.viewData			= {};
}
// MyvercoController.inheritsFrom( PageController );
MyvercoContactController.inheritsFrom( StandardController );
MyvercoContactController.prototype.swap = function(onComplete){
	this.$body				= $('body');
	this.$page				= this.$body.find('.js-page');
	this.$header			= this.$body.find('.js-page-header');

	return true;
}
MyvercoContactController.prototype.on = function(){
	new ContactForm({
		template: "contact",
		templateBase: "/myverco/forms/",
		$overlay: this.$body.find('.js-contact-form')
	});
}
MyvercoContactController.prototype.off = function(){

}